/**
 * Feature-Flags (R7) — beim App-Load aus /api/v1/app/date-format geladen
 * (gemeinsamer System-Settings-Read). Bis dahin gelten sichere Defaults.
 *
 * LIGA_LIVE: false = Liga nur für BL Vertrieb/Admin sichtbar (Vorschau),
 * true = für alle berechtigten Vertriebs-Rollen. Pflege in
 * /admin/system/datumsformat (System-Settings) — Rollback ohne Deploy.
 */

let _ligaLive = false;

/**
 * ARENA_LIVE (Ausbaustufe 4): false = die Arena sehen nur BL Vertrieb/Admin.
 *
 * 🔑 Eigener Schalter, nicht an `liga_live` gekoppelt — die Arena kann fertig
 * sein, während die Einzel-Liga noch nicht freigeschaltet ist. Und wie dort gilt:
 * das Ausblenden im Nav ist KEIN Schutz, das Backend gatet noch einmal.
 */
let _arenaLive = false;

/**
 * 🔒 Baustein 4: sieht dieser Nutzer die eigene Buchungsstrecke?
 *
 * Justin 16.08.: *„Buchungen und Anfragen bitte erstmal nur für mich sichtbar
 * machen — auch in der Sidebar."*
 *
 * ⚠️ **Default false.** Die Strecke läuft im Testbetrieb; ein Flag, das vor dem
 * ersten Laden „sichtbar" sagt, zeigt sie kurz allen. Die LISTE steht
 * serverseitig (`BUCHUNG_SICHTBAR_FUER`) — hier kommt nur ein Ja/Nein an.
 */
let _buchungSichtbar = false;

export function setFeatureFlags(f: { liga_live?: boolean; arena_live?: boolean; buchung_sichtbar?: boolean }): void {
  _ligaLive = f.liga_live === true;
  _arenaLive = f.arena_live === true;
  _buchungSichtbar = f.buchung_sichtbar === true;
}

export function istBuchungSichtbar(): boolean {
  return _buchungSichtbar;
}

export function isLigaLive(): boolean {
  return _ligaLive;
}

export function isArenaLive(): boolean {
  return _arenaLive;
}
